import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import SponsorshipLevelListing from 'views/admin/sponsorshipLevels/SponsorshipLevelsListing'
import SponsorshipLevelForm from 'views/admin/sponsorshipLevels/SponsorshipLevelsForm'

const SponsorshipLevels = () => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <SponsorshipLevelListing />
      </Route>
      <Route path={`${path}/new`}>
        <SponsorshipLevelForm displayContext="page" />
      </Route>
      <Route path={`${path}/edit/:id`}>
        <SponsorshipLevelForm displayContext="page" />
      </Route>
    </Switch>
  )
}

export default SponsorshipLevels
